export default __webpack_public_path__ + "static/media/3.a06a7cbc.png";